import { twMerge } from 'tailwind-merge';

export function ProgressBar({ value = 0 }: { value: number }) {
  const colors = [
    value <= 100 && 'bg-primaryColor-normal',
    value < 60 && 'bg-secondaryColor-normal',
    value < 25 && 'bg-tertiaryColor-normal',
  ];

  return (
    <div className='progress overflow-hidden bg-neutralColor-lighter rounded-full w-full h-5 relative'>
      <div className={twMerge(['w-full h-full rounded-full', ...colors])} style={{ width: `${value}%` }}></div>
      <div className={twMerge(['absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2', value >= 60 ? 'text-white' : 'text-black'])}>
        {value}%
      </div>
    </div>
  );
}
